import { useTheme } from '@emotion/react'
import { NextSeo } from 'next-seo'

import TermAndPrivacyLayout from '@/modules/termsAndPrivacy/components/TermAndPrivacyLayout'
import { renderTemplate } from '@/modules/termsAndPrivacy/helpers'

import { MainLayout } from '@/layouts/MainLayout'

const TYPE = 'terms'

export function TermsOfUse(): React.ReactElement {
  const theme = useTheme()

  return (
    <>
      <NextSeo title="Terms of Use" />
      <TermAndPrivacyLayout>
        <h1>ข้อกำหนดและเงื่อนไขการใช้งาน</h1>
        <p>
          ข้อกำหนดและเงื่อนไขในการใช้งานฉบับนี้
          (&quot;ข้อกำหนดและเงื่อนไขฯ&quot; หรือ &quot;สัญญา&quot;)
          เป็นข้อตกลงระหว่าง Consent Wow (&quot;บริษัท เอ็นเดต้าธอธ จำกัด&quot;
          หรือ &quot;เรา&quot;) และท่าน (&quot;ผู้ใช้&quot; หรือ
          &quot;ท่าน&quot;) ข้อกำหนดและเงื่อนไขฯ
          ฉบับนี้ได้กำหนดข้อกำหนดและเงื่อนไขทั่วไปสำหรับการใช้งานเว็บไซต์
          Consent Wow ผลิตภัณฑ์หรือบริการ และการเข้าร่วมกิจกรรมที่เกี่ยวข้องกับ
          Consent Wow ใด ๆ ก็ตามของท่าน (เรียกรวมกันว่า “Consent Wow”
          &quot;เว็บไซต์ Consent Wow&quot; หรือ &quot;บริการ&quot;)
        </p>

        {renderTemplate(TYPE)}
        <br />
        <hr />
        <br />
        <p
          id="end-content"
          css={theme.mq({ fontWeight: '--fontWeights-medium' })}
        >
          เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อวันที่ 1 มิถุนายน 2565
        </p>
      </TermAndPrivacyLayout>
    </>
  )
}

TermsOfUse.getLayout = function getLayout(page: React.ReactNode) {
  return <MainLayout>{page}</MainLayout>
}
